import { ArtworkCard, ArtworkCardProps } from 'components/artwork/ArtworkCard'
import { SearchedArtworksContainer } from 'components/carousels/SearchedArtworksContainer'
import { Skeletons } from 'components/common/Skeletons'
import { pagination } from 'constants/homepage'
import { useLatestSearches } from 'hooks'
import { PropsWithClassName } from 'types'
import { saveScroll } from 'utils/scroll'

interface SearchArtworksCarouselProps extends PropsWithClassName {
  maxCount?: number
  minCount?: number
  key?: string
  maxResults?: number
}

export const SearchedArtworksCarousel = ({
  maxCount,
  minCount,
  key = 'Index-searched-artworks',
  maxResults = pagination.pageSize,
  className,
}: SearchArtworksCarouselProps) => {
  const { searches: searchedArtworks } = useLatestSearches<ArtworkCardProps>({
    key,
    entities: 'artwork',
    computeEntities: true,
    computeIds: false,
    maxResults,
  })

  if (searchedArtworks) {
    if (typeof maxCount === 'number' && searchedArtworks.length >= maxCount)
      return null

    if (typeof minCount === 'number' && searchedArtworks.length < minCount)
      return null
  }

  return !searchedArtworks || searchedArtworks?.length ? (
    <SearchedArtworksContainer className={className}>
      {searchedArtworks?.map((artwork, index) => (
        <ArtworkCard
          key={index}
          {...artwork}
          onLinkClick={() => saveScroll({ redirectedFrom: 'homepage' })}
        />
      ))}
      {!searchedArtworks && <Skeletons type='artwork' />}
    </SearchedArtworksContainer>
  ) : null
}
